











































































import { defineComponent, computed } from '@vue/composition-api';

import { useSyncQueryVariableObject, useRouter } from 'vivat';

import getComponents from '@/gql/getComponents.gql';
import getComponent from '@/gql/getComponent.gql';
import deleteComponent from '@/gql/deleteComponent.gql';

import component from '@/table/component';
import PanelWithFileInput from '@/components/Component/PanelWithFileInput.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

import PanelWithTagsEditor from '@/components/Component/PanelWithTagsEditor.vue';
import PanelWithTagGroupDisplay from '@/components/Component/PanelWithTagGroupDisplay.vue';
import { useResult, useQuery, useMutation } from '@vue/apollo-composable';

const List = defineComponent({
  components: {
    PanelWithTagGroupDisplay,
    CommonModalWithPreset,
    PanelWithTagsEditor,
    PanelWithFileInput,
  },
  setup() {
    const { route, routerPersist } = useRouter(['filter']);

    const { result: getComponentResult } = useQuery(getComponent, () => ({ id: route.value.params.id }));
    const comp = useResult(getComponentResult, null, (data: any) => data.component);

    const filter = useSyncQueryVariableObject('filter', {
      search: '',
      filterTags: [],
    });

    const getComponentsVariables = computed(() => {
      const vars: { [key: string]: any } = {};
      if (filter.search !== '') vars.searchName = `%${filter.search}%`;
      if (filter.filterTags.length > 0) vars.filterTags = [...filter.filterTags].join(',');
      return vars;
    });

    function onRowClick(event: any) {
      routerPersist.query.push({ name: 'ComponentView', params: { id: event.item.id } });
    }
    function onRightPanelClose() {
      routerPersist.query.push({ name: 'ComponentList' });
    }

    const deleteComponentMutation = useMutation(deleteComponent, () => ({
      refetchQueries: ['getComponents'],
    }));

    async function onDelete(context: any) {
      await deleteComponentMutation.mutate({ id: context.id });
      if (route.value.params.id) routerPersist.query.push({ name: 'ComponentList' });
    }

    return {
      comp,
      onDelete,
      onRowClick,
      onRightPanelClose,
      filter,
      component,
      getComponents,
      getComponentsVariables,
      getComponentsResult: (data: any) => data.components,
    };
  },
});

export default List;
